import { Edit, Printer } from 'lucide-react';
import { Badge, CardList, TablePagination, ActionMenu } from '@/components/ui';

interface RequestMobileListProps {
  isLoading: boolean;
  requests: any[];
  onSelectItem: (item: any) => void;
  getStatusVariant: (status: string) => any;
  getTypeVariant: (type: string) => any;
}

export function RequestMobileList({ 
  isLoading, 
  requests, 
  onSelectItem, 
  getStatusVariant, 
  getTypeVariant 
}: RequestMobileListProps) {
  return (
    <div className="lg:hidden space-y-4">
      <CardList
        isLoading={isLoading}
        items={requests}
        renderCard={(item: any) => (
          <div key={item.id} className="bg-white rounded-md border border-slate-200 p-3 space-y-3 shadow-sm cursor-pointer hover:border-emerald-200 transition-colors" onClick={() => onSelectItem(item)}>
            {/* Khối chia 2 phần: Nội dung (Trái) & Badges (Phải) */}
            <div className="flex justify-between items-start gap-3">
              {/* Phần 1: Nội dung */}
              <div className="flex flex-col gap-1.5 flex-1">
                <h4 className="sm:text-sm text-xs font-medium text-slate-800 leading-snug whitespace-normal break-words">
                  <span className="text-blue-600 font-semibold">[{item.code || 'N/A'}]</span> - {item.title}
                </h4>
                
                <div className="flex flex-col gap-1 mt-1">
                  <div className="flex items-center gap-2 sm:text-sm text-xs text-slate-600">
                    <span className="text-slate-400 font-normal">Khu vực:</span>
                    <span className="font-medium">{item.zone?.zone_name || item.project?.name}</span>
                  </div>
                  <div className="flex items-center gap-2 sm:text-sm text-xs text-slate-600">
                    <span className="text-slate-400 font-normal">Ngày tạo:</span>
                    <span className="font-medium">{new Date(item.createdAt).toLocaleDateString('vi-VN')}</span>
                  </div>
                </div>
              </div>

              {/* Phần 2: Badges */}
              <div className="flex flex-col gap-2 items-end shrink-0">
                <Badge variant={getStatusVariant(item.status)} className="whitespace-nowrap shadow-sm">{item.status}</Badge>
                <Badge variant={getTypeVariant(item.type)} className="whitespace-nowrap shadow-sm">{item.type}</Badge>
              </div>
            </div>

            {/* Dưới cùng: Người tạo & Thao tác */}
            <div className="flex items-center justify-between pt-3 border-t border-slate-50">
              <div className="flex items-center gap-2">
                <img src={item.requester?.avatar_url || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(item.requester?.full_name || 'A')} alt="" className="w-6 h-6 rounded-full border border-slate-100" />
                <span className="sm:text-sm text-xs font-medium text-slate-700">{item.requester?.full_name}</span>
              </div>
              <ActionMenu 
                items={[
                  { label: 'Chỉnh sửa', icon: Edit, onClick: (e: any) => { e.stopPropagation(); } },
                  { label: 'In', icon: Printer, onClick: (e: any) => { e.stopPropagation(); } }
                ]}
              />
            </div>
          </div>
        )}
      />
      <div className="bg-white rounded-md border border-slate-200 p-3 flex justify-between items-center sm:text-sm text-xs text-slate-500 shadow-sm">
        <TablePagination
          currentPage={1}
          totalItems={82}
          pageSize={10}
          onPageChange={() => {}}
          itemLabel="đề xuất"
        />
      </div>
    </div>
  );
}
